// Helpers to carry a post-authentication redirect ("next") intent across
// regular register/login and the Google OAuth round-trip (via sessionStorage).
const KEY = 'kalendarik_post_auth_next';

export function isSafeNext(next) {
  return typeof next === 'string' && next.startsWith('/') && !next.startsWith('//');
}

export function rememberNext(next) {
  if (!isSafeNext(next)) return;
  try { sessionStorage.setItem(KEY, next); } catch { /* ignore */ }
}

export function consumeNext(fallback = '/dashboard') {
  let v = null;
  try {
    v = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch { /* ignore */ }
  return isSafeNext(v) ? v : fallback;
}
